import { similarPositionsMock, restaurantImagesMock } from '@restworld/utils-common';

const restaurantPictures = [...restaurantImagesMock];
const defaultImageArgs = {
  restaurantPictures,
};
const similarPositions = [...similarPositionsMock];
const defaultCardArgs = { items: [...similarPositions] };
export { defaultImageArgs, restaurantPictures, defaultCardArgs, similarPositions };
